import { createGetLotteryGroupsSelector } from "../../store/state/sportsbook-betting/sportsbook-betting-selectors";
import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { MapStateToPropsFactory } from "react-redux";
import { LotteryGroups } from "@ppb/tbd-store/helpers/sportsbook-betting";

export type StateProps = {
  lotteryGroups: LotteryGroups;
};

export type ContainerProps = {
  hasAvailabilityHints: boolean;
  showCustomKeyboard?: boolean;
  shouldFocusStakeField?: boolean;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const getLotteryGroups = createGetLotteryGroupsSelector();

  return (appState: BetslipApplicationState) => {
    return {
      lotteryGroups: getLotteryGroups(appState),
    };
  };
};
